export function finMethodFromCountry(
  countryCca2: string | undefined
): 'VISA' | 'MBWAY' {
  return countryCca2 === 'PT' ? 'MBWAY' : 'VISA';
}
